import React from 'react';
import Slider from 'react-slick';
import { testimonials } from '../data/testimonialsData'; // Import the data
import './Testimonials.css'; // Create this CSS file

const Testimonials: React.FC = () => {
  const settings = {
    dots: true, // Show dots for navigation
    infinite: true,
    speed: 500,
    slidesToShow: 1, // Show one testimonial at a time
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000, // Slower speed for reading
    pauseOnHover: true,
    adaptiveHeight: true, // Adjust height based on content
  };

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="container">
        <h2 className="welcome-heading">What People Say</h2> {/* Or "Client Testimonials" */}
        <Slider {...settings} className="testimonial-slider">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-slide">
              <blockquote className="testimonial-quote">
                "{testimonial.quote}"
              </blockquote>
              <p className="testimonial-author">
                <strong>{testimonial.name}</strong><br />
                <span className="testimonial-title">{testimonial.title}</span>
              </p>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;